const STORE_INITIATE_VALUE = {
  AUTH_INITIATE: {
    user: {},
  },
  SPINNER_INITIATE: {
    value: false,
  },
  RELEVANT_REPORT: {
    reportDetail: {},
  },
  EDITING_REPORT: {
    editingReport: null,
  },
  REPORTS_DATA: {
    reportsData: null,
  },
  NEXT_REPORT: {
    reportData: null,
    LastEvaluatedKey: null,
  },
};

export default STORE_INITIATE_VALUE;



// WEBPACK FOOTER //
// ./src/constants/initialstore.js